import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  REQUEST_DETAIL_GREEN_CERTIFICATE_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_DETAIL_GREEN_CERTIFICATE_ADD,
  REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL,
  REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE,
} from '../actions';
import {
  RequestDetailGreenCertificateListSuccess,
  RequestDetailGreenCertificateListError,
  RequestDetailGreenCertificateSearchGeoCountryListSuccess,
  RequestDetailGreenCertificateSearchGeoCountryListError,
  RequestDetailGreenCertificateSearchHealthAgencyListSuccess,
  RequestDetailGreenCertificateSearchHealthAgencyListError,
  RequestDetailGreenCertificateAddSuccess,
  RequestDetailGreenCertificateAddError,
  RequestDetailGreenCertificateDetailSuccess,
  RequestDetailGreenCertificateDetailError,
  RequestDetailGreenCertificateUpdateSuccess,
  RequestDetailGreenCertificateUpdateError
} from '../actions';
 
export function* watchRequestDetailGreenCertificateList() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_LIST, onRequestDetailGreenCertificateList);
}

export function* watchRequestDetailGreenCertificateSearchHealthAgencyList() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_HEALTH_AGENCY_LIST, onRequestDetailGreenCertificateSearchHealthAgencyList);
}

export function* watchRequestDetailGreenCertificateSearchGeoCountryList() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_SEARCH_GEO_COUNTRY_LIST, onRequestDetailGreenCertificateSearchGeoCountryList);
}

export function* watchRequestDetailGreenCertificateAdd() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_ADD, onRequestDetailGreenCertificateAdd);
}

export function* watchRequestDetailGreenCertificateDetail() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_DETAIL, onRequestDetailGreenCertificateDetail);
}

export function* watchRequestDetailGreenCertificateUpdate() {
  yield takeEvery(REQUEST_DETAIL_GREEN_CERTIFICATE_UPDATE, onRequestDetailGreenCertificateUpdate);
}

const onRequestDetailGreenCertificateListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_green_certificate/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestDetailGreenCertificateUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_green_certificate/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}


const onRequestDetailGreenCertificateAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_green_certificate/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestDetailGreenCertificateSearchGeoCountryListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestDetailGreenCertificateSearchHealthAgencyListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/health_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestDetailGreenCertificateDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_green_certificate/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onRequestDetailGreenCertificateList(data) {
  try {
    const response = yield call(onRequestDetailGreenCertificateListAsync, data.payload);
    yield put(RequestDetailGreenCertificateListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailGreenCertificateListError(error));
  }
}

function* onRequestDetailGreenCertificateSearchHealthAgencyList(data) {
  try {
    const response = yield call(onRequestDetailGreenCertificateSearchHealthAgencyListAsync, data.payload);
    yield put(RequestDetailGreenCertificateSearchHealthAgencyListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailGreenCertificateSearchHealthAgencyListError(error));
  }
}

function* onRequestDetailGreenCertificateSearchGeoCountryList(data) {
  try {
    const response = yield call(onRequestDetailGreenCertificateSearchGeoCountryListAsync, data.payload);
    yield put(RequestDetailGreenCertificateSearchGeoCountryListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailGreenCertificateSearchGeoCountryListError(error));
  }
}

function* onRequestDetailGreenCertificateAdd(data) {
  try {
      const response = yield call(onRequestDetailGreenCertificateAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailGreenCertificateAddSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailGreenCertificateAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestDetailGreenCertificateDetail(data) {
  try {
    const response = yield call(onRequestDetailGreenCertificateDetailAsync, data.payload);
    yield put(RequestDetailGreenCertificateDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestDetailGreenCertificateDetailError(error));
  }
}

function* onRequestDetailGreenCertificateUpdate(data) {
  try {
      const response = yield call(onRequestDetailGreenCertificateUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailGreenCertificateUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailGreenCertificateUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestDetailGreenCertificateList),
    fork(watchRequestDetailGreenCertificateSearchGeoCountryList),
    fork(watchRequestDetailGreenCertificateSearchHealthAgencyList),
    fork(watchRequestDetailGreenCertificateAdd),
    fork(watchRequestDetailGreenCertificateDetail),
    fork(watchRequestDetailGreenCertificateUpdate),
  ]);
} 